const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const request = async (url, options = {}) => {
  const response = await fetch(`${API_BASE}${url}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });

  const contentType = response.headers.get('content-type') || '';
  const isJson = contentType.includes('application/json');
  const data = isJson ? await response.json() : await response.text();

  if (!response.ok) {
    const message = (data && data.message) || 'Request failed.';
    const errors = data && data.errors ? data.errors : {};
    throw { message, errors };
  }

  return data;
};

export const submitCreatorRegistration = (payload) => request('/api/creator-registration', {
  method: 'POST',
  body: JSON.stringify(payload),
});

export const loginAdmin = (credentials) => request('/api/admin/login', {
  method: 'POST',
  body: JSON.stringify(credentials),
});

export const getAdminOverview = (token) => request('/api/admin/overview', {
  headers: { Authorization: `Bearer ${token}` },
});

export const getAdminCreators = (token, params = {}) => {
  const query = new URLSearchParams(params).toString();
  return request(`/api/admin/creators${query ? `?${query}` : ''}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getCreatorDetail = (token, id) => request(`/api/admin/creators/${id}`, {
  headers: { Authorization: `Bearer ${token}` },
});

export const updateCreator = (token, id, updates) => request(`/api/admin/creators/${id}`, {
  method: 'PATCH',
  body: JSON.stringify(updates),
  headers: { Authorization: `Bearer ${token}` },
});

export const exportCreators = (token, type = 'xlsx') => {
  const url = type === 'csv' ? '/api/admin/export.csv/plain' : '/api/admin/export.csv';
  window.open(`${API_BASE}${url}?token=${encodeURIComponent(token)}`, '_blank');
};
